import React from "react";
import { useNavigate } from 'react-router-dom';
import Navbar from "./Navbar";
import Footer from "./Footer";


const TermsAndConditions = () => {

    const navStyle = {
        backgroundColor: "#f0f0f0",
        padding: "12px 12px 12px 5%",
        borderRadius: "5px",
      };
    
      const ulStyle = {
        listStyleType: "none",
        padding: 0,
        margin: 0,
        display: "flex",
        alignItems: "center",
        fontSize: "11px",
      };
    
      const liStyle = {
        marginRight: "6px",
      };
    
      const linkStyle = {
        textDecoration: "none",
        color: "#000",
        cursor:"pointer "
      };
    
  const containerStyle = {
    // marginTop: "10px",
    textAlign: "justify",
    gap: "20px",
    padding:"3% 5% 3% 5%",
    backgroundColor:"rgb(232, 240, 238)",
    color:"rgb(93, 64, 55)"
  };

  const headingStyle = {
    fontSize: "30px",
    margin:"0",
    
  };

  const paragraphStyle = {
    lineHeight: "1.8",
    textAlign: "justify",
  };

    const navigate = useNavigate();
      const Home = () => {
        navigate("/")
      }

  return (
    <>
    <Navbar />
    <section>
      <nav style={navStyle}>
        <ul style={ulStyle}>
          <li style={liStyle}>
            <a onClick={Home} style={linkStyle}>HOME</a>
          </li>
          <li style={liStyle}>&gt;</li>
          <li>
            <a style={linkStyle}>TERMS & CONDITIONS</a>
          </li>
        </ul>
      </nav>
    </section>
    <div className="qoffee-page container" style={containerStyle}>
      <h1 style={headingStyle}>TERMS AND CONDITIONS</h1>
      <p style={paragraphStyle}>
        PLEASE READ THIS TERMS OF SERVICE AGREEMENT CAREFULLY. BY USING THIS WEBSITE OR ORDERING PRODUCTS FROM THIS WEBSITE YOU AGREE TO BE BOUND BY ALL OF THE TERMS AND CONDITIONS OF THIS AGREEMENT. This Agreement governs your use of www.magicroastqoffee.com (the "Website"), operated by MAGICROAST QOFFEE PRIVATE LIMITED (the "Company"). It includes policies referenced herein and may be updated from time to time. Continued use of this Website after changes are posted constitutes your acceptance of the updated Agreement. If you do not agree to these terms, please discontinue use of the Website.
      </p>

      <h2 style={headingStyle}>I. Products</h2>
      <p style={paragraphStyle}>
        This Website offers products ("Products") for sale. By placing an order, you agree to the terms herein. All rights, trademarks, and layouts belong to MAGICROAST QOFFEE PRIVATE LIMITED. Copying, reselling, or redistributing is prohibited. You are responsible for paying any applicable taxes (GST, etc.).
      </p>

      <h2 style={headingStyle}>II. Content and Use of Website</h2>
      <p style={paragraphStyle}>
        Website content is provided for personal, non-commercial use. Third-party links are provided for convenience. The Company is not responsible for content on external sites. Users agree not to engage in illegal activity, disrupt others’ use, or post harmful content. By posting content, you grant the Company a royalty-free license to use it. The Company reserves the right to moderate user interactions.
      </p>

      <h2 style={headingStyle}>III. Disclaimer of Warranties</h2>
      <p style={paragraphStyle}>
        This Website and Products are provided "as is" and "as available." MAGICROAST QOFFEE PRIVATE LIMITED disclaims all warranties, including implied warranties of merchantability, fitness for a particular purpose, and non-infringement. No guarantee is made regarding accuracy, reliability, or results. Some jurisdictions may not allow exclusions, and in such cases, limitations will apply to the extent permissible.
      </p>

      <h2 style={headingStyle}>IV. Limitation of Liability</h2>
      <p style={paragraphStyle}>
        The Company’s total liability shall not exceed the amount paid for purchased products (excluding shipping/handling). The Company shall not be liable for any indirect, incidental, or consequential damages. Certain jurisdictions may not allow this limitation, in which case it will be enforced to the maximum extent allowed.
      </p>

      <h2 style={headingStyle}>V. Indemnification</h2>
      <p style={paragraphStyle}>
        You agree to indemnify and hold harmless MAGICROAST QOFFEE PRIVATE LIMITED and its affiliates from all claims and liabilities arising from your use of the Website, violation of this Agreement, or infringement of any rights. The Company may seek written assurances of your indemnification obligations and participate in any defense.
      </p>

      <h2 style={headingStyle}>VI. Privacy</h2>
      <p style={paragraphStyle}>
        Please review our Privacy Policy to understand how we collect and use personal data. Continued use of the Website indicates agreement with the Privacy Policy.
      </p>

      <h2 style={headingStyle}>VII. Agreement to be Bound</h2>
      <p style={paragraphStyle}>
        By accessing the Website or ordering Products, you agree to be bound by this Agreement and all terms contained herein.
      </p>

      <h2 style={headingStyle}>VIII. General Terms</h2>
      <p style={paragraphStyle}>
        <strong>Force Majeure:</strong> The Company is not liable for delays caused by events beyond its control (e.g., natural disasters, war, strikes).<br />
        <strong>Termination:</strong> The Company may terminate your access for violating terms. Upon termination, you may not access the Website.<br />
        <strong>Governing Law:</strong> This Agreement is governed by the laws of Maharashtra, India. Disputes will be resolved in courts of Maharashtra.<br />
        <strong>Waiver and Severability:</strong> Any failure to enforce a provision is not a waiver. If any part is unenforceable, the rest remains effective.<br />
        <strong>Statute of Limitation:</strong> Any claim must be filed within 1 year of its occurrence.<br />
        <strong>Class Action Waiver:</strong> Claims must be brought individually, not as part of a class action.<br />
        <strong>Customer Communication:</strong> Unless opted out, you consent to future communication from the Company or its agents.<br />
        <strong>Opt-Out:</strong> You can opt out of communications by (1) replying during a call, (2) emailing support, or (3) using an opt-out link in email communications.
      </p>
    </div>
    <Footer />
    </>
  );
};

export default TermsAndConditions;
